import * as React from 'react';
import { useEffect, useState } from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import cn from 'classnames';

import { useTheme } from '../../theme';
import { closeIcon } from '../icons';
import { Props } from '../types';
import SwipeableDrawer from '@mui/material/SwipeableDrawer/SwipeableDrawer';
import ModalTransitionComponent from '../../ModalTransitionComponent';
import { useBlurActiveElement } from '../../hooks';

/**
 * @deprecated
 */
const Modal: React.FC<Props> = ({
	closeClassName,
	isRounded,
	closeButtonRenderer,
	slideUp,
	bottomDrawer,
	bottomDrawerClassName,
	...props
}) => {
	const [dialogIsMounted, setDialogIsMounted] = useState(!props.mountOnEnter);
	const { Modal: css } = useTheme('Modal');
	const defaultProps: Partial<DialogProps> = {
		scroll: 'body',
		maxWidth: 'lg'
	};

	if (slideUp) {
		defaultProps.TransitionComponent = ModalTransitionComponent;
	}

	/**
	 * WEBSKY-5566:
	 * Перед закрытием модалки/диалогового окна, снимаем фокус с активного элемента (если есть),
	 * чтобы избежать ошибки "blocked aria-hidden".
	 */
	useBlurActiveElement(props.open);

	useEffect(() => {
		if (props.open && !dialogIsMounted) {
			setDialogIsMounted(true);
		}
	}, [props.open, dialogIsMounted]);

	const dialogClasses = props.classes ? props.classes : {};

	const renderContent = () => {
		return (
			<>
				{props.extraTitle && <div className={cn(css.extraTitle)}>{props.extraTitle}</div>}
				{props.onClose && !closeButtonRenderer && (
					<span
						className={cn(css.closeIcon, closeClassName, {
							[css.closeIcon_mobileFullScreen]: props.fullScreen
						})}
						onClick={props.onClose}
					>
						{closeIcon}
					</span>
				)}
				{props.onClose && closeButtonRenderer && closeButtonRenderer(props.onClose)}
				{dialogIsMounted && props.children}
			</>
		);
	};

	if (bottomDrawer) {
		return (
			props.open && (
				<SwipeableDrawer
					onClose={props.onClose ? props.onClose : () => {}}
					onOpen={() => {}}
					open={props.open}
					anchor="bottom"
					closeAfterTransition={false}
					classes={{
						...dialogClasses,
						paper: cn(
							css.modal,
							css.modal_bottom,
							{ [css.modal_mobileFullScreen]: props.fullScreen, [css.modal_rounded]: isRounded },
							dialogClasses.paper,
							bottomDrawerClassName
						)
					}}
				>
					{renderContent()}
				</SwipeableDrawer>
			)
		);
	}

	return (
		<Dialog
			{...defaultProps}
			{...props}
			onClose={props.onClose}
			closeAfterTransition={false}
			classes={{
				...dialogClasses,
				paper: cn(
					css.modal,
					{ [css.modal_mobileFullScreen]: props.fullScreen, [css.modal_rounded]: isRounded },
					dialogClasses.paper
				),
				scrollBody: cn(css.scrollBody, dialogClasses.scrollBody)
			}}
		>
			{renderContent()}
		</Dialog>
	);
};

export default Modal;
